<template>
    <v-list-item v-if="locales.length > 1" class="language-switcher pa-0">
        <v-menu v-model="menu" :close-on-content-click="false">
            <template v-slot:activator="{props}">
                <v-list-item class="language-switcher__label-item" v-bind="props">
                    <v-list-item-title>
                        <div class="d-flex align-center">
                            <language-label :language="locale" show-current-lang text-button />
                            <v-icon end>mdi-menu-down</v-icon>
                        </div>
                    </v-list-item-title>
                </v-list-item>
            </template>
            <v-list density="compact">
                <v-list-item
                    v-for="code in locales"
                    :key="code"
                    :disabled="showTranslationKeys"
                    @click="switchLanguage(code)"
                >
                    <language-label :language="code" bold />
                </v-list-item>
            </v-list>
        </v-menu>
    </v-list-item>
</template>

<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import {CHANGE_LOCALE_EVENT, EventBus, SWITCH_LANGUAGE} from '@/utils/event-bus'
    import {axiosInstance} from '@/utils/axios-accessor'
    import LanguageLabel from '@/components/snippets/LanguageLabel.vue'

    @Component({
        components: {LanguageLabel},
    })
    export class LanguageSwitcher extends Vue {
        menu = false

        mounted() {
            EventBus.$on(SWITCH_LANGUAGE, this.switchLanguage)
        }

        beforeUnmount() {
            EventBus.$off(SWITCH_LANGUAGE, this.switchLanguage)
        }

        switchLanguage(localeCode) {
            this.$i18n.setLocale(localeCode)
            EventBus.$emit(CHANGE_LOCALE_EVENT, localeCode)
            this.menu = false
        }

        get locales() {
            return Object.values(this.$conf.public.locales)
        }

        get locale() {
            return this.$i18n.locale
        }

        get showTranslationKeys() {
            return adminRuntimeStore.showTranslationKeys
        }
    }

    export default toNative(LanguageSwitcher)
</script>

<style>
    .language-switcher {
        display: flex;
        padding: 1rem;
    }

    .languages {
        display: flex;
        justify-content: flex-end;
    }

    .language {
        padding-left: 0.25rem;
        cursor: pointer;
    }

    .language.active {
        text-decoration: underline;
    }

    .language:hover span {
        text-decoration: underline;
    }

    .language:not(:last-child):after {
        content: '|';
        padding-left: 0.25rem;
    }

    @media (max-width: 991px) {
        .language-switcher {
            padding: 0;
        }
    }
</style>
